export default __webpack_public_path__ + "static/media/lbs-graph.1ecd0499.png";